import React from 'react'
import { Grid } from '@material-ui/core'
import PageLayout from '../common/PageLayout'
import PageHeading from '../common/PageHeading'
import SydLinkButton from '../../../../components/commonDesign/LinkButton'
import Divider from '../../../../components/atoms/Divider'
import ChatHistorySearch from './ChatHistorySearch'

function HistoryHome () {
  return (
    <PageLayout variant='constrained'>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <PageHeading title='Your Chat History' size='lg' className='mt-5'>
            <SydLinkButton size='sm' variant='outline' icon='add' to='/denali-ai/new'>New Chat</SydLinkButton>
          </PageHeading>
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <ChatHistorySearch />
        </Grid>
      </Grid>

    </PageLayout>
  )
}

export default HistoryHome
